import { render, staticRenderFns } from "./videoSetUp.vue?vue&type=template&id=13dd096c&scoped=true&"
import script from "./videoSetUp.vue?vue&type=script&lang=js&"
export * from "./videoSetUp.vue?vue&type=script&lang=js&"
import style0 from "./videoSetUp.vue?vue&type=style&index=0&id=13dd096c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd096c",
  null
  
)

export default component.exports